const advertWrap = {
  advert: document.getElementById('jsAdvert') as HTMLElement,
  advertWrap: document.querySelectorAll(
    '.jsAdvertWrap',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.setAdvert();
  },

  setAdvert() {
    this.advertWrap.forEach((wrap) => {
      wrap.innerHTML += this.advert.innerHTML;
    });
  },
};

export default advertWrap;
